import { Store } from 'src/store/index';

const isDesignLoading = (store: Store) => store.design.isLoading;

export default isDesignLoading;
